import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const reasignarListaTurnos = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.ADP.TURNOS.REASIGNAR_LISTA_TURNOS}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default reasignarListaTurnos;